module.exports = __webpack_public_path__ + "img/Windshield.f71d714f.jpg";